import { expVal } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';

export const useCommentActionsVisibility = (isFabricPage?: boolean) => {
	const isNotFabricPage = isFabricPage === false;
	const areFeaturesEnabled =
		// eslint-disable-next-line confluence-feature-gating/no-preconditioning
		fg('confluence_frontend_content_wrapper') &&
		expVal('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false);

	const isFabricPageWithFeaturesEnabled = !isNotFabricPage && areFeaturesEnabled;

	const showMainActions = isFabricPageWithFeaturesEnabled;
	const showLegacyMainActions = !isFabricPageWithFeaturesEnabled;

	return { showMainActions, showLegacyMainActions };
};
